import React, { useEffect, useState } from 'react'
import { ColumnState } from 'ag-grid-community'
import {
  DragableItem,
  TwoListDragableModal,
} from 'components/AgGrid/components/TwoListDragableModal/TwoListDragableModal'
import { BaseTableColumn } from 'ts/types/commonTable.types'

interface CustomizeColumnsProps {
  onClose: (hiddenColumns?: string[], visibleColumns?: string[]) => void
  columns: ColumnState[]
  columnDefs: BaseTableColumn[]
}

const CustomizeColumns: React.FC<CustomizeColumnsProps> = ({
  onClose,
  columns,
  columnDefs,
}: CustomizeColumnsProps) => {
  const [items, setItems] = useState<DragableItem[]>([])

  useEffect(() => {
    const ret = columnDefs
      .filter(
        (column) =>
          column.colId !== 'searchField' &&
          column.colId !== 'calcGuidanceFloorAsyncNetAmount' &&
          column.colId !== 'calcGuidanceFloorAsyncPercentage'
      )
      .map((item) => {
        const columnStatusIndex = columns.findIndex(
          (col) => col.colId === item.colId || col.colId === item.key
        )
        const column: DragableItem = {
          key: item.colId ?? item.key,
          id: item.colId ?? item.key,
          label: item.userProvidedColDef?.headerName ?? item.label,
          hide: !!(columnStatusIndex >= 0 ? columns[columnStatusIndex].hide : false),
          selected: false,
        }
        // ignore select/expand column
        if (
          column.id !== 'selected-column' &&
          column.id !== 'expand-column' &&
          column.id !== 'delete-column'
        ) {
          return column
        } else {
          return null
        }
      })
      .sort(
        (a, b) =>
          columns.findIndex((column) => column.colId === a?.id) -
          columns.findIndex((column) => column.colId === b?.id)
      )
      .filter((item): item is DragableItem => !!item)
    setItems(ret)
  }, [])

  return (
    <TwoListDragableModal
      title="Customize Columns"
      items={items}
      onApply={(hiddenColumns, visibleColumns) =>
        onClose(
          hiddenColumns.map((col) => col.id ?? ''),
          visibleColumns.map((col) => col.id ?? '')
        )
      }
      onClose={onClose}
    />
  )
}

export default CustomizeColumns
